import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { StarRow } from "./Pill";

export default function ProviderCard({ p, hideEditorBadge = false }) {
  return (
    <div className="card-hover flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6">
      <div className="flex items-start justify-between">
        <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-[var(--navy)] font-display text-[14px] font-extrabold text-white">
          {p.mono}
        </div>
        {p.editor && !hideEditorBadge && (
          <span className="rounded-full bg-amber-50 px-2.5 py-1 text-[11px] font-bold text-amber-600">
            Editor's Choice
          </span>
        )}
      </div>

      <h3 className="font-display mt-4 text-[18px] font-bold leading-tight text-[var(--ink)]">{p.name}</h3>
      <div className="mt-1.5 flex items-center gap-1.5 text-[13px]">
        <StarRow n={p.stars} size={14} />
        {p.reviews != null ? (
          <>
            <span className="font-bold text-[var(--ink)]">{p.rating}</span>
            <span className="text-slate-400">· {p.reviews} reviews</span>
          </>
        ) : (
          <span className="text-slate-400">No Google Reviews</span>
        )}
      </div>

      <div className="mt-4 flex flex-wrap gap-1.5">
        {p.tags.map((t, i) => (
          <span key={i} className="rounded-md bg-slate-100 px-2.5 py-1 text-[12px] font-medium text-slate-600">{t}</span>
        ))}
      </div>

      <p className="mt-4 flex-1 text-[14px] leading-relaxed text-slate-500">{p.desc}</p>

      {p.location && (
        <div className="mt-4 flex items-center gap-1.5 text-[13px] text-slate-500">
          <MapPin size={14} className="text-slate-400" /> {p.location}
        </div>
      )}

      <Link
        to={`/providers/${p.slug}`}
        className="mt-5 inline-flex w-full items-center justify-center rounded-xl border border-slate-200 px-4 py-2.5 text-[14px] font-semibold text-[var(--ink)] transition-colors hover:bg-slate-50"
      >
        View Profile
      </Link>
    </div>
  );
}
